'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import H from "../defs/FilePdf.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      d.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
const I = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, f(a({ ref: e }, o), { weights: H })));
I.displayName = "FilePdf";
export {
  I as FilePdf
};
